import { ErrorMessage } from "@hookform/error-message";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "components/button";
import Password from "components/password";
import { useForm } from "react-hook-form";
import formServices from "services/form-builder-services";
import textServices from "services/text-services";
import { Label } from "theme/theme";
import { TitlePassword } from "./text.style";

function ChangePassword({ state, handleChange, onSubmit }: any) {
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(formServices.formGenerateSchema(["password", "password_confirm"])) })

  function onFormSubmit(data: any) {
    handleChange(data)
    onSubmit(data.password)
  }

  return (
    <div className="flex flex-col flex-1 md:pt-10">
      <TitlePassword className="text-center text-4xl font-bold uppercase my-7 mx-7">{textServices.findByText('password/title', 'Recuperar contraseña')}</TitlePassword>
      <form className="flex h-full justify-between flex-col gap-4 mx-7 mb-7" onSubmit={handleSubmit(onFormSubmit)} noValidate>
        <div className="flex-1 flex flex-col gap-4">
          <div className="gap-2 flex flex-col">
            <Label className="text-start text-2xl font-bold uppercase">Contraseña nueva</Label>
            <Password
              className="text-center saira font-bold text-sm"
              type="password"
              placeholder="**********"
              name="password"
              defaultValue={state?.password}
              {...register("password")}
            />
            <ErrorMessage errors={errors} name="password" />
          </div>
          <div className="gap-2 flex flex-col">
            <Label className="text-start text-2xl font-bold uppercase">Confirmar contraseña nueva</Label>
            <Password
              className="text-center saira font-bold text-sm"
              type="password"
              placeholder="**********"
              name="password_confirm"
              defaultValue={state?.password_confirm}
              {...register("password_confirm")}
            />
            <ErrorMessage errors={errors} name="password_confirm" />
          </div>
        </div>
        <Button>
          <p className="uppercase">Restablecer contraseña</p>
        </Button>
      </form>
    </div>
  )
}

export default ChangePassword;